"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom.iterable");
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _multiProductSharing = require("@/api/operationManagement/multiProductSharing");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MultiProductSharing',
  data: function data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      page: 1,
      size: 20,
      queryData: {
        shareTitle: '',
        phone: '',
        nickname: '',
        isShared: '',
        upStatus: ''
      },
      hasOffReason: false,
      previewImgVisible: false,
      previewImgUrl: '',
      statusDialogVisible: false,
      statusSubmitting: false,
      statusForm: {
        id: null,
        upStatus: 1,
        offReason: ''
      },
      statusRules: {
        offReason: [{
          required: true,
          message: '请输入下架原因',
          trigger: 'blur'
        }]
      },
      sharedDialogVisible: false,
      sharedSubmitting: false,
      sharedRow: null,
      sharedNextValue: null,
      previewVisible: false,
      previewLoading: false,
      previewDetail: null
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    onInquire: function onInquire() {
      this.page = 1;
      this.getList();
    },
    onReset: function onReset() {
      this.queryData = {
        shareTitle: '',
        phone: '',
        nickname: '',
        isShared: '',
        upStatus: ''
      };
      this.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _this = this;
        var params, queryKeys, res, data, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              params = {
                page: this.page,
                size: this.size
              };
              queryKeys = ['shareTitle', 'phone', 'nickname', 'isShared', 'upStatus'];
              queryKeys.forEach(function (key) {
                if (_this.queryData[key] !== '' && _this.queryData[key] !== null && _this.queryData[key] !== undefined) {
                  params[key] = _this.queryData[key];
                }
              });
              _context.n = 2;
              return (0, _multiProductSharing.pageGoodShare)(params);
            case 2:
              res = _context.v;
              data = res.data || {};
              this.tableData = data.data || [];
              this.total = data.total || 0;
              this.hasOffReason = this.tableData.some(function (r) {
                return r.upStatus === 0;
              });
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('查询分享清单失败', _t);
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    previewImage: function previewImage(url) {
      this.previewImgUrl = url;
      this.previewImgVisible = true;
    },
    // 会员详情
    onUserDetails: function onUserDetails(row) {
      if (!row.memberId) return;
      this.$router.push({
        path: '/member/userDetails',
        query: {
          memberId: row.memberId,
          nickname: row.nickname
        }
      });
    },
    onToggleShared: function onToggleShared(row, val) {
      this.sharedRow = row;
      this.sharedNextValue = val;
      row.isShared = val === 1 ? 0 : 1;
      this.sharedDialogVisible = true;
    },
    onSharedCancel: function onSharedCancel() {
      this.sharedDialogVisible = false;
      this.sharedRow = null;
      this.sharedNextValue = null;
    },
    onSharedConfirm: function () {
      var _onSharedConfirm = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (this.sharedRow) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.sharedSubmitting = true;
              _context2.p = 2;
              _context2.n = 3;
              return (0, _multiProductSharing.updateShareStatus)({
                id: this.sharedRow.id,
                opType: 1,
                isShared: this.sharedNextValue
              });
            case 3:
              this.$message.success('操作成功');
              this.sharedRow.isShared = this.sharedNextValue;
              this.sharedDialogVisible = false;
              this.sharedRow = null;
              this.sharedNextValue = null;
              _context2.n = 5;
              break;
            case 4:
              _context2.p = 4;
              _t2 = _context2.v;
              console.error('更新共享状态失败', _t2);
            case 5:
              _context2.p = 5;
              this.sharedSubmitting = false;
              return _context2.f(5);
            case 6:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 4, 5, 6]]);
      }));
      function onSharedConfirm() {
        return _onSharedConfirm.apply(this, arguments);
      }
      return onSharedConfirm;
    }(),
    onEdit: function onEdit(row) {
      this.statusForm = {
        id: row.id,
        upStatus: row.upStatus,
        offReason: row.offReason || ''
      };
      this.statusDialogVisible = true;
    },
    onStatusDialogClosed: function onStatusDialogClosed() {
      var _this2 = this;
      this.statusForm = {
        id: null,
        upStatus: 1,
        offReason: ''
      };
      this.$nextTick(function () {
        if (_this2.$refs.statusForm) {
          _this2.$refs.statusForm.clearValidate();
        }
      });
    },
    onStatusSubmit: function () {
      var _onStatusSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var payload, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              if (!(this.statusForm.upStatus === 0 && !this.statusForm.offReason.trim())) {
                _context3.n = 1;
                break;
              }
              this.$message.warning('下架原因不能为空');
              return _context3.a(2);
            case 1:
              this.statusSubmitting = true;
              _context3.p = 2;
              payload = {
                id: this.statusForm.id,
                opType: 2,
                upStatus: this.statusForm.upStatus,
                offReason: this.statusForm.offReason
              };
              _context3.n = 3;
              return (0, _multiProductSharing.updateShareStatus)(payload);
            case 3:
              this.$message.success('操作成功');
              this.statusDialogVisible = false;
              this.getList();
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t3 = _context3.v;
              console.error('更新上下架失败', _t3);
            case 5:
              _context3.p = 5;
              this.statusSubmitting = false;
              return _context3.f(5);
            case 6:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4, 5, 6]]);
      }));
      function onStatusSubmit() {
        return _onStatusSubmit.apply(this, arguments);
      }
      return onStatusSubmit;
    }(),
    onPreview: function () {
      var _onPreview = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(row) {
        var res, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              this.previewDetail = null;
              this.previewVisible = true;
              this.previewLoading = true;
              _context4.p = 1;
              _context4.n = 2;
              return (0, _multiProductSharing.queryGoodShareDetail)({
                id: row.id
              });
            case 2:
              res = _context4.v;
              this.previewDetail = res.data || {};
              _context4.n = 4;
              break;
            case 3:
              _context4.p = 3;
              _t4 = _context4.v;
              console.error('查询清单详情失败', _t4);
            case 4:
              _context4.p = 4;
              this.previewLoading = false;
              return _context4.f(4);
            case 5:
              return _context4.a(2);
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function onPreview(_x) {
        return _onPreview.apply(this, arguments);
      }
      return onPreview;
    }()
  }
};